import React from 'react'
import UseLang from '../../../../hooks/UseLang'

function Objetivo() {
    return (
        <div id="p2"> 
            <UseLang es>
                <h2 id="objetivo">Objetivo</h2>
                <p>Este estudio tuvo como objetivo relevar informaci&oacute;n relacionada con la ocurrencia de ataques DDoS, con el costo que estos ataques tienen para las organizaciones y tambi&eacute;n con la incorporaci&oacute;n de t&eacute;cnicas y herramientas de mitigaci&oacute;n.</p>
            </UseLang>
            <UseLang en>
                <h2 id="objetivo">Purpose</h2>
                <p>The purpose of this study was to gather information about the occurrence of DDoS attacks, the financial impact of these attacks for an organization, and the adoption of mitigation techniques and tools.</p>
            </UseLang>
            <UseLang pt>
                <h2 id="objetivo">Objetivo</h2>
                <p>Este estudo teve como objetivo coletar informações relacionadas à ocorrência de ataques DDoS, com o custo que estes ataques têm para as organizações e também à incorporação de técnicas e ferramentas de mitigação.</p>
            </UseLang>
        </div>
    )
}

export default Objetivo
